import { Box, BoxProps } from '@chakra-ui/react'

import { createWidget } from '../widget-utils'

export type SeparatorProps = BoxProps & {}

export const Separator = ({ ml, mr }: SeparatorProps) => (
  <Box
    height="59px"
    marginLeft={ml ? ml : '25px'}
    marginRight={mr ? mr : '25px'}
    borderLeft="1px solid"
    borderColor="presets.neutral.20"
  ></Box>
)

export const SeparatorWidgetDefinition = createWidget(Separator, {
  type: 'Separator',
})
